

import React, { useEffect, useState } from 'react';
import { Grid, Container, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { CustomTitle } from '../common/CustomTitle/CustomTitle';
import { DeviceTable } from './DeviceTable/DeviceTable';
import { DeviceTableNoMeasures } from './DeviceTableNoMeasures/DeviceTableNoMeasures';
import { ContractsAdminScreen } from '../contracts/ContractsAdminScreen/ContractsAdminScreen';
import MonitoringSystem from '../MonitoringSystem/MonitoringSystem';
import { PanelsProfileInfoTable } from './OtherInfoTable/PanelsProfileInfoTable';
import { useLocation } from 'react-router-dom';


export const Dashboard = () => {
  const location = useLocation();
  const [view, setView] = useState(location.state?.view || 'failAndAlarms');
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    if (location.state?.view) {
      setView(location.state.view);
      setRefreshKey(prevKey => prevKey + 1); //incrementa la clave para forzar refresco de renovacion sas
    }
  }, [location.key]);

  const handleChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
    //console.log(view);
  };

  return (
    <Container maxWidth={false} sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <CustomTitle advanced={true} title="Panel de control avanzado" />
        </Grid>

        <Grid item xs={8}>
          <MonitoringSystem />
        </Grid>

        <Grid item xs={12}>
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={handleChange}
            fullWidth
            sx={{ width: '100%' }}
          >
            <ToggleButton
              value="failAndAlarms"
              fullWidth
              sx={{
                textTransform: 'none',
                color: 'text.primary',
                backgroundColor: view === 'failAndAlarms' ? '#f0f0f0' : 'transparent',
                '&.Mui-selected': {
                  color: 'text.primary',
                  backgroundColor: '#f0f0f0',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#e0e0e0',
                },
                '&:hover': {
                  backgroundColor: '#f9f9f9',
                },
              }}
            >
              Fallos de comunicación y Alarmas
            </ToggleButton>

            <ToggleButton
              value="unsentAlarms"
              fullWidth
              sx={{
                textTransform: 'none',
                color: 'text.primary',
                backgroundColor: view === 'unsentAlarms' ? '#f0f0f0' : 'transparent',
                '&.Mui-selected': {
                  color: 'text.primary',
                  backgroundColor: '#f0f0f0',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#e0e0e0',
                },
                '&:hover': {
                  backgroundColor: '#f9f9f9',
                },
              }}
            >
              Fallo en envío de medidas
            </ToggleButton>
            <ToggleButton
              value="panelsProfileInfo"
              fullWidth
              sx={{
                textTransform: 'none',
                color: 'text.primary',
                backgroundColor: view === 'unsentAlarms' ? '#f0f0f0' : 'transparent',
                '&.Mui-selected': {
                  color: 'text.primary',
                  backgroundColor: '#f0f0f0',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#e0e0e0',
                },
                '&:hover': {
                  backgroundColor: '#f9f9f9',
                },
              }}
            >
              Especificaciones de contratos
            </ToggleButton>
            <ToggleButton
              value="adminContracts"
              fullWidth
              sx={{
                textTransform: 'none',
                color: 'text.primary',
                backgroundColor: view === 'unsentAlarms' ? '#f0f0f0' : 'transparent',
                '&.Mui-selected': {
                  color: 'text.primary',
                  backgroundColor: '#f0f0f0',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#e0e0e0',
                },
                '&:hover': {
                  backgroundColor: '#f9f9f9',
                },
              }}
            >
              Renovaciones SaS
            </ToggleButton>
          </ToggleButtonGroup>

        </Grid>

        <Grid item xs={12}>
          {view === 'failAndAlarms' && (
            <DeviceTable />
          )}

          {view === 'unsentAlarms' && (
            <DeviceTableNoMeasures />
          )}

          {view === 'adminContracts' && (
            <ContractsAdminScreen key={refreshKey} />
          )}
          {view === 'panelsProfileInfo' && (
            <PanelsProfileInfoTable />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};









